import AmexGDALearnMore from './AmexGDALearnMore';

export default AmexGDALearnMore;
